import axios from 'axios';

const trimSlashes = (value = '') => value.replace(/^\/+|\/+$/g, '');

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl.endsWith('/') ? envUrl : `${envUrl}/`;
  return `${window.location.origin}/api/`;
};

export const normalizeEndpoint = endpoint => trimSlashes(endpoint);

export const apiBaseUrl = getApiBaseUrl();

const httpClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Let axios set Content-Type automatically for FormData
    // (the default application/json header would break multipart uploads)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  error => Promise.reject(error)
);

httpClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      // Only redirect if not already on a public page
      const publicPaths = ['/login', '/forgot-password', '/reset-password'];
      if (!publicPaths.some(p => window.location.pathname.startsWith(p))) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default httpClient;
